export default __webpack_public_path__ + "static/media/1794.f752072a.png";